import { Observable } from 'rxjs/Observable';
import { Component } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Loading, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

interface Category {
  name: string;
  files: Files[];
}
interface Files {
  name: string;
  link: string;
  desc: string;
}
@Component({
  selector: 'upload',
  templateUrl: 'upload.html'
})

export class UploadComponent {
  itemDoc: AngularFirestoreDocument<Category>;
  item: Observable<Category>;
  toggle: boolean = false;
  itemsCollection: AngularFirestoreCollection<Category>;
  items: Category[];
  selCat: any;
  myForm: FormGroup;
  loading: Loading;

  constructor(public asf: AngularFirestore, public toastCtrl: ToastController, public formBuilder: FormBuilder, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    this.itemsCollection = asf.collection("Uploads", ref => ref.orderBy("order", "asc"));
    this.itemsCollection.snapshotChanges().subscribe((data) => {
      this.items = data.map((item) => {
        const data = item.payload.doc.data() as Category;
        const id = item.payload.doc.id;
        return { id, ...data }
      });
    });
    this.myForm = this.formBuilder.group({
      name: ['', Validators.required],
      desc: ['', Validators.required],
      link: ['', Validators.required],
      selCat: ['', Validators.required]
    });
  }

  submit() {
    this.presentLoadingCustom();
    this.asf.collection('Uploads/' + this.myForm.get('selCat').value + '/files').ref.orderBy("order", "desc").limit(1).get().then(collection => {
      let order = 0;
      if (!collection.empty) {
        order = Number(collection.docs[0].data().order) + 1;
      }
      const data = {
        name: this.myForm.get('name').value,
        link: this.myForm.get('link').value,
        desc: this.myForm.get('desc').value,
        order: order
      }
      this.asf.collection('Uploads/' + this.myForm.get('selCat').value + '/files').add(data).then(() => {
        this.myForm.reset();
        this.loading.dismiss();
        this.presentToast('El archivo fue subido correctamente');
      }).catch(error => {
        this.loading.dismiss();
        this.presentToast("¡Ha ocurrido un error!");
      });
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }


  showPrompt() {
    const prompt = this.alertCtrl.create({
      title: 'Agregar categoría',
      inputs: [
        {
          name: 'name',
          placeholder: 'Categoría'
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Guardar',
          handler: data => {
            if (data && data.name && data.name != '') {
              this.presentLoadingCustom();
              this.asf.collection("Uploads").ref.orderBy("order", "desc").limit(1).get().then(collection => {
                let order = 0;
                if (!collection.empty) {
                  order = Number(collection.docs[0].data().order) + 1;
                }
                this.asf.collection("Uploads").add({
                  "name": data.name,
                  "order": order,
                  "canReorder": false,
                  "collapsed": true
                }).then(() => {
                  this.loading.dismiss();
                  this.presentToast('Agregado correctamente');
                }).catch(error => {
                  this.loading.dismiss();
                  this.presentToast("¡Ha ocurrido un error!");
                });
              }).catch(error => {
                this.loading.dismiss();
                this.presentToast("¡Ha ocurrido un error!");
              });
            } else {
              this.presentToast("¡Campos vacíos!");
            }
          }
        }
      ]
    });
    prompt.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/upload/upload.ts